<template>
    <div class="seo-page__header__seo-sport-search d-flex input-group">
        <b-form-input v-model="search_string" class="flex-fill search-world-input bg-white border-0"
                      :placeholder="sportPlaceholder"></b-form-input>
        <v-select
                v-model="municipality"
                label="name"
                value="name"
                :filterable="false"
                :options="municipalities"
                :placeholder="cityPlaceholder"
                @search="onSearchCity"
                class="bg-white border-left rounded-right"
        >
            <template slot="no-options">
                Scrivi per selezionare la città nell'elenco
            </template>
            <template slot="option" slot-scope="option">
                <div class="d-center">
                    <span>{{ option.name }}</span>
                </div>
            </template>
            <template slot="selected-option" slot-scope="option">
                <div class="d-flex align-items-center justify-content-center selected d-center">
                    <span>{{ option.name }}</span>
                </div>
            </template>
        </v-select>

        <button type="button"
                @click="onSearch"
                class="btn btn-primary-orango text-uppercase seo-search-button fw-600 m-l-20">
            <i class="fas fa-search"></i>
        </button>
        <!--<button class="search-world-button seo-sport-search__btn&#45;&#45;search" @click="sendGA">
            <i class="fa fa-search"></i>
        </button>-->

    </div>
</template>

<script>
    import vSelect from 'vue-select'

    export default {
        name: 'SeoSearchNavbar',
        props: {
            url: String,
            sportPlaceholder: String,
            cityPlaceholder: String
        },
        components: {'v-select': vSelect},
        data() {
            return {
                municipality: null,
                search_string: null,
                municipalities: [],
                coords: []
            }
        },
        mounted() {
            this.getLocation();
            $(".search-world-input").keyup(function (event) {
                event.preventDefault();
                if (event.keyCode == 13) {
                    $(".search-world-button").click();
                }
            });
        },
        methods: {
            onSearch() {
                this.sendGA();
                let municipality = this.municipality ? this.municipality.name : this.getParameterByName('municipality')
                let searchString = this.search_string ? this.search_string : this.getParameterByName('search_string')
                let latitude = this.getParameterByName('latitude')
                let longitude = this.getParameterByName('longitude')

                let queryString = `${this.source}?search_string=${searchString}&municipality=${municipality}&latitude=${latitude}&longitude=${longitude}`

                location.href = queryString
            },
            onSearchCity(search, loading) {
                this.searchCity(loading, search, this);
            },
            searchCity: _.debounce((loading, search, vm) => {
                axios({
                    method: 'get',
                    url: `/municipalities?term=${search}`
                }).then((response) => {
                    vm.municipalities = response.data.municipalities;
                    loading(false);
                }).catch((error) => {
                    this.message = 'Error';
                    loading(false);
                });
            }),
            getSearchUrl() {
                if (this.coords.length != 0) {
                    return this.url +
                        '?search_string=' +
                        this.search_string +
                        '&municipality=' +
                        this.municipality.name +
                        '&latitude=' +
                        this.coords[0] +
                        '&longitude=' +
                        this.coords[1]
                } else {
                    return this.url +
                        '?search_string=' +
                        this.search_string +
                        '&municipality=' +
                        this.municipality.name +
                        '&latitude=' +
                        null +
                        '&longitude=' +
                        null
                }
            },
            getLocation() {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(this.returnPosition);
                }
            },
            returnPosition(position) {
                this.coords.push(position.coords.latitude);
                this.coords.push(position.coords.longitude);

                this.$bus.$emit('geolocalizated', {
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                });
            },
            sendGA() {
                ga('send', 'event', 'Ricerca', 'RicercaCorso', 'HomePage');
                window.location = this.getSearchUrl();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/search/SeoSearchNavbar.vue